module.exports = __webpack_public_path__ + "img/AFMS_RPM_OVER.45020f13.png";